import JourneysView from 'views/Product/TwilioEngagePage/Journeys'

const Journeys = () => <JourneysView />

export default Journeys
